import styled from 'styled-components';

import { useVideoLink } from '@/component/FileUpload/useVideoLink';

type ViewPracticalAssessmentVideoPreviewEmbedProps = { videoLink: string; rounded?: boolean };

const IFrameContainer = styled.div<{ $rounded?: boolean }>`
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  border-radius: ${({ $rounded }) => ($rounded ? '12px' : '0px')};
  border: 2px solid transparent;
  overflow: hidden;
`;

export const ViewPracticalAssessmentVideoPreviewEmbed = ({
  videoLink,
  rounded,
}: ViewPracticalAssessmentVideoPreviewEmbedProps): JSX.Element => {
  const { getEmbedUrlType } = useVideoLink();

  const embedUrl = getEmbedUrlType(videoLink).embedUrl;

  return (
    <IFrameContainer $rounded={rounded}>
      <iframe
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        title="Video"
        style={{ width: '100%', height: '100%', position: 'absolute', top: 0 }}
      />
    </IFrameContainer>
  );
};
